<template>
    <div>
        <SToolbar>
            <v-icon small class="mr-1">ic-20 ic-{{ $route.meta.icon || 'world' }} ic-col-grey</v-icon>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
        </SToolbar>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'AddressIndex',

    components: {},
    computed: {
        title() {
            return this.$route.meta.mainTitle instanceof Function ? this.$route.meta.mainTitle() : this.$t('adressen');
        },
    },
    methods: {
        getBrowserTitle() {
            return this.title;
        },
    },
};
</script>
